import React from 'react';
import ReactDOM from 'react-dom';

export interface PortalProps {
  node: HTMLElement;
  children: React.ReactNode;
}

export const Portal: React.FC<PortalProps> = ({ node, children }) => ReactDOM.createPortal(children, node);

interface ModalPortalProps {
  children: React.ReactNode;
}

export const ModalPortal: React.FC<ModalPortalProps> = ({ children }) => (
    <Portal node={document && document.getElementById('modal')!}>
        {children}
    </Portal>
);
